import React, { useState } from 'react';
import { Mail, MessageCircle, Share2, Check, ShoppingBag } from 'lucide-react';
import { paintingSlug } from '../data/mockGalleryData';

// Contact options for "Inquire / Buy a print". Set these in Netlify → Environment variables.
// Facebook Messenger (the art page) is always available as a fallback.
const inquiryEmail = process.env.REACT_APP_INQUIRY_EMAIL;
const inquiryWhatsApp = (process.env.REACT_APP_INQUIRY_WHATSAPP || '').replace(/\D/g, ''); // e.g. 919876543210
const messengerUrl = process.env.REACT_APP_INQUIRY_MESSENGER_URL || 'https://m.me/artbydavidraj';

const InquireShare = ({ painting }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${window.location.origin}/painting/${paintingSlug(painting)}`;
  const inquiryText = `Hi David, I'm interested in your painting "${painting.title}" – could you tell me about buying the original or a print? ${shareUrl}`;

  const handleShare = async () => {
    const shareData = { title: painting.title, text: `"${painting.title}" by ${painting.artist}`, url: shareUrl };
    if (navigator.share) {
      try { await navigator.share(shareData); } catch (e) { /* user cancelled */ }
      return;
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      window.prompt('Copy this link:', shareUrl);
    }
  };

  const btn = 'flex-1 min-w-[120px] flex items-center justify-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors';

  return (
    <div className="space-y-4">
      <div className="bg-gray-50 border rounded-lg p-4">
        <h4 className="font-semibold text-gray-800 mb-1 flex items-center gap-2">
          <ShoppingBag size={18} className="text-amber-700" />
          Inquire / Buy a print
        </h4>
        <p className="text-sm text-gray-600 mb-3">Interested in the original or a print of this painting? Get in touch.</p>
        <div className="flex flex-wrap gap-2">
          {inquiryEmail && (
            <a
              className={`${btn} bg-amber-600 hover:bg-amber-700 text-white`}
              href={`mailto:${inquiryEmail}?subject=${encodeURIComponent(`Inquiry: ${painting.title}`)}&body=${encodeURIComponent(inquiryText)}`}
            >
              <Mail size={16} /> Email
            </a>
          )}
          {inquiryWhatsApp && (
            <a
              className={`${btn} bg-green-600 hover:bg-green-700 text-white`}
              href={`https://wa.me/${inquiryWhatsApp}?text=${encodeURIComponent(inquiryText)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          )}
          <a
            className={`${btn} bg-blue-600 hover:bg-blue-700 text-white`}
            href={messengerUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MessageCircle size={16} /> Messenger
          </a>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <button onClick={handleShare} className={`${btn} border border-gray-300 hover:bg-gray-100 text-gray-800`}>
          {copied ? <Check size={16} className="text-green-600" /> : <Share2 size={16} />}
          {copied ? 'Link copied!' : 'Share this painting'}
        </button>
        <a
          className={`${btn} border border-green-600 text-green-700 hover:bg-green-50`}
          href={`https://wa.me/?text=${encodeURIComponent(`"${painting.title}" by ${painting.artist} ${shareUrl}`)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MessageCircle size={16} /> Share on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default InquireShare;
